<div class="notifications">
    <div class="" *ngFor="let item of notifications">
        <div class="item" [ngClass]="item.Alert">
            {{item.Body}}
        </div>
    </div>
</div>


